module.exports = global["Phaser"] = require("-!./phaser-split.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser-ce/build/custom/phaser-split.js
// module id = 33
// module chunks = 0